import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Checkbox, Modal } from 'gatorcomponents';
import withErrorBoundary from '@/utils/errorBoundary';
import * as Styles from './AutomaticCleaningConsentModal.styles';

const AutomaticCleaningConsentModal = ({
  content,
  onConfirm,
  onClose,
  onCancel,
  testId,
}) => {
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleToggleAcceptedTerms = useCallback(() => {
    setAcceptedTerms(previousState => !previousState);
  }, []);

  const handleCancel = useCallback(() => {
    if (onCancel) {
      onCancel();
      return;
    }

    onClose();
  }, [onCancel, onClose]);

  const handleConfirm = useCallback(() => {
    if (acceptedTerms) {
      onConfirm();
    }
  }, [acceptedTerms, onConfirm]);

  return (
    <>
      <Styles.ModalCardOverride />
      <Modal
        maxWidth={600}
        noContentPadding
        noHeader
        onClose={onClose}
        testId={testId}
      >
        <Styles.Container>
          <Styles.Title>{content.title}</Styles.Title>

          <Styles.Description>
            {content.description}
          </Styles.Description>

          <Styles.CheckboxLabel
            onClick={handleToggleAcceptedTerms}
            data-testid={`${testId}__checkbox`}
          >
            <Checkbox checked={acceptedTerms} id={`${testId}-accepted-terms`} />
            <Styles.CheckboxText>{content.checkboxLabel}</Styles.CheckboxText>
          </Styles.CheckboxLabel>

          <Styles.Actions>
            <Button
              label={content.cancelButtonLabel}
              onClick={handleCancel}
              size="xlarge"
              variant="tertiary"
              version="v2"
              width="fit-content"
            />

            <Button
              label={content.confirmButtonLabel}
              onClick={handleConfirm}
              size="xlarge"
              variant="primary"
              version="v2"
              width="fit-content"
              disabled={!acceptedTerms}
            />
          </Styles.Actions>
        </Styles.Container>
      </Modal>
    </>
  );
};

AutomaticCleaningConsentModal.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    checkboxLabel: PropTypes.string.isRequired,
    cancelButtonLabel: PropTypes.string.isRequired,
    confirmButtonLabel: PropTypes.string.isRequired,
  }).isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  testId: PropTypes.string,
};

AutomaticCleaningConsentModal.defaultProps = {
  onCancel: null,
  testId: 'gator-protect-automatic-cleaning-consent-modal',
};

export default withErrorBoundary(AutomaticCleaningConsentModal, 'AutomaticCleaningConsentModal');
